module.exports = __webpack_public_path__ + "static/fbOG-66d65e926a7d9a3052cfdf555b575d6d.png";